var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEckoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1220.999,
    height: 1221,
    viewBox: "0 0 1220.999 1221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.028,
    y1: -0.028,
    x2: 0.859,
    y2: 0.859,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00b8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54168",
    "data-name": "Group 54168",
    transform: "translate(-253.472 -62.499)",
    opacity: 0.1,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_13",
    "data-name": "Subtraction 13",
    d: "M610,1220a614.916,614.916,0,0,1-122.94-12.4,606.446,606.446,0,0,1-218.126-91.785,611.7,611.7,0,0,1-221-268.384,607.353,607.353,0,0,1-35.549-114.5,616.368,616.368,0,0,1,0-245.882,607,607,0,0,1,91.784-218.116A611.9,611.9,0,0,1,372.552,47.932,607.267,607.267,0,0,1,487.06,12.4a615.784,615.784,0,0,1,245.869,0,606.317,606.317,0,0,1,218.126,91.785,611.814,611.814,0,0,1,221.01,268.381,607.417,607.417,0,0,1,35.538,114.5,615.826,615.826,0,0,1,0,245.882,606.44,606.44,0,0,1-91.784,218.113,611.825,611.825,0,0,1-268.383,221.013A607.073,607.073,0,0,1,732.929,1207.6,614.864,614.864,0,0,1,610,1220ZM609.989,59.195C306.281,59.195,59.2,306.285,59.2,610s247.084,550.813,550.792,550.813,550.8-247.1,550.8-550.813S913.7,59.195,609.989,59.195Zm0,1049.488c-274.982,0-498.7-223.707-498.7-498.684s223.714-498.709,498.7-498.709,498.7,223.721,498.7,498.709S884.971,1108.682,609.989,1108.682Zm96.3-898.562L407.22,509.207V714.6l299.066,299.065V808.186l-196.295-196.3L706.286,415.619V210.12Zm0,301.873L675.13,543.152l-68.72,68.762,68.72,68.753,31.156,31.168,31.167-31.168,68.709-68.753-68.709-68.762-31.167-31.159h0Z",
    transform: "translate(253.972 62.999)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEckoBackground);
export default __webpack_public_path__ + "static/media/ecko_background.88098da4fd0d406565c7c18a249c0392.svg";
export { ForwardRef as ReactComponent };